export const PathsToSkip = ['handle_error', 'error'];

const PathDeviceSuccessPage = 'device_success_page';
const PathDeviceCodePage = 'device_init_code';

// Check if path is device success page
export const skipErrorCheck = (path: string) => {
  return path === PathDeviceSuccessPage || path == PathDeviceCodePage;
}
